import { z } from 'zod';

export enum StandardAnalyticEventCategoryStatus {
  Active = 'Active',
  Deprecated = 'Deprecated',
}

export const StandardAnalyticEventCategorySchema = z.object({
  id: z.uuid(),
  name: z.string().min(1),
  status: z.enum(StandardAnalyticEventCategoryStatus),
  created: z.string().date(),
  updated: z.string().date(),
});

export type StandardAnalyticEventCategory = z.infer<typeof StandardAnalyticEventCategorySchema>;

export interface StandardAnalyticEventCategoryFindAllParams {
  q?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  orderDirection?: 'asc' | 'desc';
  status?: StandardAnalyticEventCategoryStatus;
}
